// extracted by mini-css-extract-plugin
export var sliderRange = "_qr-2";
export var sliderRoot = "_qr-0";
export var sliderThumb = "_qr-3";
export var sliderTrack = "_qr-1";